export const gtagsCategories = {
  SEARCH: "search",
  LEAD: "lead",
  CONTACT: "contact",
  APP: "app",
};

export const gtagsActions = {
  FIND_AGENCY: "TrouverAgence",
  DIRECTIONS: "DirectionGM",
  BECOME_FRANCHISE: "DevenirFranchise",
  BECOME_FRANCHISE_FIRST_STEP: "FirstStepDevenirFranchise",
  BECOME_FRANCHISE_SECOND_STEP: "SecondStepDevenirFranchise",
  CONTACT_EMAIL: "EmailContact",
  CONTACT_PHONE: "PhoneContact",
  APP_IOS: "IosApp",
  APP_ANDROID: "AndroidApp",
};

export const gtagsSend = (eventCategory, eventLabel) => {
  if (window.gtag) {
    window.gtag("event", "click", {
      event_category: eventCategory,
      event_label: eventLabel,
    });
  }
};
